export enum BaseRoutesEnum {
    // commands
    commandes = '/commandes',
}
